import React from "react"
import { connect } from "react-redux"

import BootstrapTable from "react-bootstrap-table-next"
import Loader from "../../Loader/Loader.js"
import {
  MetricTable,
  sortNumeric,
  ComponentWithUrl,
  TableTitleBarChart,
  renderLegendsForTable,
  Error
} from "./../../Utils/Utils.js"

const metric = (cell, row, rowIndex, enumObject) => {
  const props = { ...cell, ...enumObject }
  return <MetricTable {...props} />
}

class AdsTop5 extends ComponentWithUrl {
  render() {
    const { loading, data } = this.props

    if (loading) {
      return <Loader minHeight={350} col={"col-12"} />
    }

    if (data.hasData === false) {
      return <Error minHeight={360} />
    }

    // add unique ids
    data.data.forEach((d, i) => d.id = i);
    
    const columns = [
      {
        dataField: "name",
        text: "Ad Name / Impressions",
        style: { width: "500px", minWidth: "500px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableTitleBarChart,
        sort: true
      }, {
        dataField: "ctr",
        text: "CTR",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        sort: true,
        sortFunc: sortNumeric
      }, {
        dataField: "cpc",
        text: "CPC",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        sort: true,
        sortFunc: sortNumeric
      }, {
        dataField: "cpa",
        text: "CPA",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        sort: true,
        sortFunc: sortNumeric
      }, {
        dataField: "total",
        text: "Total Spent",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        sort: true,
        sortFunc: sortNumeric
      }
    ];

    const defaultSorted = [{
      dataField: 'total',
      order: 'desc'
    }];

    return (
      <div className="col-sm-12 d-flex mt-3">
        <section className="widget">
          <header className="widget__header mb-3">
            <h5 className="widget__title">{this.props.title}</h5>
          </header>
          {renderLegendsForTable()}
          <BootstrapTable
            keyField="id"
            data={data.data}
            columns={columns}
            //odyContainerClass="table-large-metrics" // there is no such option in v2
            defaultSorted={defaultSorted}
            striped={false}
            hover={false}
            bordered={false}
          />
        </section>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url]
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true
  }
}

export default connect(mapStateToProps)(AdsTop5)
